module.exports = __webpack_public_path__ + "media/images/teach-f6637e8becbe78b71d531a6127f7c4ed.svg";